<template>
  <div
    class="MyMapSousDomaine"
    :id="sousDomaine.sousDomaineId.toString()"
    v-show="isShown"
  >
    <div class="MyMapSousDomaine__content" @click="emit('navigate', sousDomaine)">
      <span class="MyMapSousDomaine__lib">{{ libelleDynamique(sousDomaine.sousDomaineLib, sousDomaine.sousDomaineLibEn) }}</span>
      <span class="MyMapSousDomaine__count">{{ indicateurCount }}</span>
      <Icon icon="mdi:chevron-right" class="MyMapSousDomaine__chevron" size="20" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SousDomaine } from '@/models/interfaces/SousDomaine'
import { useMyMapStore } from '@/stores/myMapStore'
import { useAttributStore } from '@/stores/attributStore'
import Icon from '@/components/ui/Icon.vue'
import { libelleDynamique } from '@/utils/libelleDynamique'
import { computed } from 'vue'

const props = defineProps<{
  sousDomaine: SousDomaine
}>()

const emit = defineEmits<{
  navigate: [sousDomaine: SousDomaine]
}>()

const mapStore = useMyMapStore()
const attributStore = useAttributStore()

const isShown = computed(() => !mapStore.activeAtlas.leftPanel.active)

const indicateurCount = computed(
  () => attributStore.getIndicateursBySousdomaineId(props.sousDomaine.sousDomaineId).length,
)
</script>

<style lang="scss">
.MyMapSousDomaine {
  display: flex;
  flex-flow: column nowrap;
  padding: 0.5rem 0.75rem;
  background: rgb(var(--v-theme-surface));
  border-bottom: 1px solid var(--neutral-border);
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &__content {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 0.5rem;
    min-height: var(--panel-row-min-height);
  }

  &__lib {
    font-size: var(--panel-label-size);
    font-weight: 500;
    color: rgb(var(--v-theme-main-blue));
    flex: 1;
    min-width: 0;
  }

  &__count {
    font-size: var(--panel-label-size);
    color: var(--panel-label-color);
    flex-shrink: 0;
  }

  &__chevron {
    font-size: 1.25rem;
    color: rgb(var(--v-theme-main-blue));
    flex-shrink: 0;
  }
}
</style>
